import './Contactos.css';
import 'boxicons/css/boxicons.min.css';
import Header from "../Header/Header.js"
import Footer from "../Footer/Footer.js"

function Contactos() {
    const contactos = [
        {
            plataforma: "Instagram",
            icono: "bx bxl-instagram",
            descripcion: "Síguenos en @tresatec para conocer lo que hacemos y ver nuestros proyectos.",
            enlace: "https://www.instagram.com/tresatec/",
        },
        {
            plataforma: "WhatsApp", 
            icono: "bx bxl-whatsapp",
            descripcion: "Escríbenos por WhatsApp, estaremos encantados de ayudarte.",
            enlace: "https://wa.me/message/ORWIOZ4UP74NM1",
        },
        {
            plataforma: "Email",
            icono: "bx bx-envelope", 
            descripcion: "Envía un correo a tresatec1@gmail.com para consultas detalladas.",
            enlace: "mailto:tresatec1@gmail.com?subject=Consulta&body=¡Hola! Quisiera realizar una consulta.",
        },
        {
            plataforma: "LinkedIn",
            icono: "bx bxl-linkedin",
            descripcion: "Conéctate con nosotros profesionalmente por LinkedIn.",
            enlace: "https://www.linkedin.com/company/tresatec",
        }
    ];

    return (
        <>
        <Header/>
        <section className="contactos-section">
            <div className="contactos-container">
                <div className="contactos-header">
                    <span className="contactos-badge">Conectemos</span>
                    <h2>Estamos aquí para ayudar a tu organización</h2>
                    <p>
                        Elegí el canal que prefieras y conversemos sobre cómo Tresaedu puede transformar tu institución.
                    </p>
                </div>
                
                <div className="contactos-grid">
                    {contactos.map((contacto, index) => (
                        <div key={index} className="contacto-card">
                            <div className="contacto-icon">
                                <i className={contacto.icono}></i>
                            </div>
                            <h3>{contacto.plataforma}</h3>
                            <p>{contacto.descripcion}</p>
                            <a 
                                href={contacto.enlace}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contacto-btn"
                            >
                                Contactar
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
        <Footer/>
        </>
    );
}

export default Contactos;